import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { PostLocationRequest } from "./interfaces";

@Injectable()
export class LocationApiService {
  #http = inject(HttpClient);

  public setLocation(request: PostLocationRequest) {
    return this.#http.post('location', request);
  }
}